module.exports = __webpack_public_path__ + "media/images/icon__locked@2x-ef5887f3d43f01c6b9f10ac0680d9ea7.png";